// extracted by mini-css-extract-plugin
export default {"errorIconContainer":"src-components-Modules-revamp-ContentTabEdit-css-module__errorIconContainer--MP85G"};